import * as React from "react";
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import HighchartsExporting from 'highcharts/modules/exporting'
import {useEffect, useState} from "react";
import Api, {APIs} from "../../../../Api";
import {useNavigate} from "react-router-dom";
import {useSelector} from "react-redux";
import Box from "@mui/material/Box";



const ProvincialDist = () => {
    const navigate = useNavigate();
    const params = useSelector((state: any) => state.dashboard)

    if (typeof Highcharts === 'object') {
        HighchartsExporting(Highcharts)
    }
    const [province, setProvinceDist] = useState([]);
    useEffect(() => {
        Api.get(APIs.MoPD_PROVINCE_DIST, params).then((payload: any) => {
            if (payload) {
                setProvinceDist(payload)
            }
        })
    }, [params])
    const data = province.map((info: any) => ({
        name: info.name,
        y: info.projects,
        needs: info.needs,
        sliced: true
    }))
    const chartOptions = {
        chart: {
            type: 'pie',
        },
        title: {
            text: 'Provincial Distribution'
        },
        tooltip: {
            pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
        },
        accessibility: {
            point: {
                valueSuffix: '%'
            }
        },
        plotOptions: {
            pie: {
                allowPointSelect: true,
                colors: ["#2458a7", "#ee330c", "#918f7e", "#ffad0a",
                    "#0022ff", "#5b9411"],
                cursor: 'pointer',
                depth: 35,
                dataLabels: {
                    y: -18,
                    x: 10,
                    padding: 4,
                    zIndex: 50,
                    softConnector: false,
                    enabled: true,
                    style: {
                        textOverflow: 'ellipsis',
                        fontSize: '10px',
                        fontStyle: 'bold',
                    },
                    format: '{point.name} <br/> Projects: {point.y} <br/> Needs:{point.needs}<br/> {point.percentage:.1f}% '
                }
            },
            series: {
                innerSize: '50%',
                point: {
                    events: {
                        click: function (e: any) {
                            let p = "";
                            let i = 0;
                            for (let key in params) {
                                let value = params[key]
                                if (key == "region") {
                                    value = e.point.name
                                }
                                p += i === 0 ? `${key}=${value}` : `&${key}=${value}`
                                i++
                            }
                            navigate("/projects?" + p)
                        }
                    }
                }
            }
        },
        series: [{
            name: 'projects',
            colorByPoint: true,
            data: data
        }]
    };
    return (
        <React.Fragment>
            <Box sx={{width: "100%", height: "100%"}}>
                <HighchartsReact
                    highcharts={Highcharts}
                    options={chartOptions}
                />
            </Box>
        </React.Fragment>
    );
}

export default ProvincialDist;
